// extracted by mini-css-extract-plugin
module.exports = {"XPowerCompoment":"XPower_XPowerCompoment__jyK3M"};